export const ReviewCard = ({ title, description, quote, imgUrl }) => (
  <div className="review-card">
    {imgUrl && (
      <div className="review-card-img">
        <img src={imgUrl} alt={title} loading="lazy" />
      </div>
    )}
    <div className="review-card-body">
      <h4>{title}</h4>
      {description && <p className="review-card-desc">{description}</p>}
      <p className="review-card-quote">“{quote}”</p>
    </div>
  </div>
);
